import api from 'config/Api/Api';

const baseEndpoint = 'v1/register-account';

export default {

  registerAccount( data ) {
    return api.post( baseEndpoint, data );
  },

  verifyAccountToken( token ) {
    return api.get( `${baseEndpoint}/active-user/${token}` );
  },
};
